// GAVION X5: "Best call hours" (Reports) and the dialer hint.
export const callHoursEn = {
  title: "Best call hours",
  description:
    "Answer and demo rates by day and hour, in the lead's local time",
  local_time:
    "Lead's local time (America/Toronto when the zone is unknown). From %{from} to %{to}.",
  filters: {
    label: "Call hours filters",
    period: "Period",
    days: {
      30: "Last 30 days",
      90: "Last 90 days",
      365: "Last 12 months",
    },
    trade: "Trade",
    all_trades: "All trades",
    region: "Region",
    rep: "Rep",
    all_reps: "Whole team",
    scope: "Calls",
    scope_me: "My calls",
    scope_team: "Whole team (aggregated)",
    metric: "Measure",
    metrics: {
      connect: "Answer rate",
      demo: "Demo rate",
    },
  },
  heatmap: {
    title: "%{metric} by day and hour",
    cell: "%{day} %{hour}:00: %{smart_count} call, %{rate} |||| %{day} %{hour}:00: %{smart_count} calls, %{rate}",
    cell_thin:
      "%{day} %{hour}:00: %{smart_count} call — not enough data |||| %{day} %{hour}:00: %{smart_count} calls — not enough data",
    cell_empty: "%{day} %{hour}:00: no calls",
    legend_low: "Low",
    legend_high: "High (%{rate})",
    legend_thin: "Not enough data (fewer than %{min} calls)",
    cell_note: "Each cell shows the number of calls.",
  },
  table: {
    day: "Day",
    hour: "Hour",
    dials: "Calls",
    connect: "Answer",
    demo: "Demos",
  },
  recommendations: {
    title: "Best windows",
    for: "%{trade}: %{window}, %{rate} answer rate",
    window: "%{day} %{from}:00–%{to}:00",
    detail:
      "%{smart_count} call, %{demo} demo rate |||| %{smart_count} calls, %{demo} demo rate",
    none: "Not enough calls to recommend a window (at least %{min} calls per window).",
    sample_note: "One-hour windows with at least %{min} calls.",
  },
  hint: {
    label: "Best time for this trade",
    text: "Best time: %{window} (%{rate} answer rate)",
  },
};
